import { useToast } from '@shared/components/toast';
import { useGetQuoteResponseMessageQuery } from '@shared/generated/graphql';

type UseDraftQuoteResponseOptions = {
  quoteIds: string[];
  originatorId?: string;
  draftingInstructions?: string;
  draftTemplateType?: string;
};

const useDraftQuoteResponse = ({
  quoteIds,
  originatorId,
  draftingInstructions,
  draftTemplateType,
}: UseDraftQuoteResponseOptions) => {
  const { sendToast } = useToast();
  const { data, loading, refetch } = useGetQuoteResponseMessageQuery({
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        quoteIds,
        originatorId,
        draftingInstructions,
        draftTemplateType,
      },
    },
    onError: () => {
      sendToast('Error generating draft response', {
        variant: 'error',
        isDismissible: true,
      });
    },
  });

  return {
    message: data?.getQuoteResponseMessage?.message ?? undefined,
    isLoading: loading,
    refetch,
  };
};

export default useDraftQuoteResponse;
